/**
 * /public/css/form.css
 */

import React from "react";

const DEFAULT_TYPE = "dashed";
const TYPE_LIST = ["dashed", "solid", "invert", "link", "menu-link"];

export default function ButtonIcon(props) {
    // Combine component className
    const className = ["button-icon"];
    Array.isArray(props.className) && className.push.call(className, props.className);
    typeof props.className === "string" && className.push(props.className);
    props.noBorder && className.push("no-border");
    props.noMargin && className.push("no-margin");
    props.small && className.push("small");

    const cleanProps = { ...props };
    delete cleanProps.icon;
    delete cleanProps.noBorder;
    delete cleanProps.noMargin;
    delete cleanProps.small;

    // Type(Style)
    let foundType = false;
    for (const type of TYPE_LIST) {
        if (cleanProps[type]) {
            foundType = type;
            className.push(type);
        }

        delete cleanProps[type];
    }

    !foundType && className.push(DEFAULT_TYPE);

    return (
        <button type="button" {...cleanProps} className={className.join(" ")}>
            <div className="button-icon-border"></div>
            <span style={{ position: "relative", zIndex: 1 }}>{props.icon}</span>
        </button>
    );
}
